export default __webpack_public_path__ + "static/media/hero_img.bf26cd0f.jpeg";